import { RemarkToCodeMapping } from "@industronics/fids-utils";

export const getDisplayColor = (RemarkToCodeMappingKey: string) => {
    let result = "";
    switch (RemarkToCodeMappingKey) {
        case RemarkToCodeMapping.DELAYED:
        case RemarkToCodeMapping.CANCELLED:
        case RemarkToCodeMapping.GATE_CLOSED:
            result = "text-red";
            break;
        case RemarkToCodeMapping.FINAL_CALL:
        case RemarkToCodeMapping.LAST_BAG:
            result = "text-warning";
            break;

        case RemarkToCodeMapping.DEPARTED:
        case RemarkToCodeMapping.LANDED:
            result = "text-done";
            break;
        case RemarkToCodeMapping.GATE_OPEN:
        case RemarkToCodeMapping.OPEN:
        case RemarkToCodeMapping.CAROUSEL_OPEN:
            result = "text-pre";
            break;
        default:
            result = "text-defualt";
            break;
    };
    return result;
};

export const handleGateChange = (gate: string) => {
    if (!gate) return;
    const firstChar = gate.match(/[A-Za-z]/)?.[0] || "";
    const numericPart = gate.match(/\d+/)?.[0].replace(/^0+/, "") || "";
    return firstChar + numericPart;
};

export const toCamelCase = (prop: string): string => {
    if (prop) return prop.replace(/-([a-z])/g, (match, letter) => letter.toUpperCase());
    return "";
};

export type ActionType = "Create" | "Edit" | "Delete" | "Publish";

